import { getWindow } from './helpers';
import { AppFactory } from './bootstrap';
import * as cookie from 'js-cookie';
import { persistState } from './persistence';

interface AppCreateCallback {
  (theSignupFlow: AppFactory): void;
}

const executeOnload = (createTheSignupFlow: AppFactory): void => {
  const win: Window = getWindow();

  const stateCookie = cookie.get('appState');

  if (stateCookie) {
    persistState(JSON.parse(atob(stateCookie)));
  }

  if (!win) {
    return undefined;
  }
  // tslint:disable-next-line no-any
  const registeredCallbacks: any = (win.__jimdoTheSignupFlow =
    win.__jimdoTheSignupFlow || []);

  registeredCallbacks.push = (fn: AppCreateCallback) => fn(createTheSignupFlow);

  while (registeredCallbacks.length) {
    registeredCallbacks.push(registeredCallbacks.shift());
  }
};

export default executeOnload;
